#import "../fragments/contacts-for-lead-fragment.graphql"

query GetContactsForLead($leadId: ID!) {
    lead(id: $leadId) {
        ...ContactsForLeadFragment
    }
}
